<template lang="pug">
v-icon(
  v-if="showChristmasTree"
  v-bind="$attrs"
) $christmasTree
</template>

<script>
import { isWithinInterval } from 'date-fns';

export default {
  computed: {
    showChristmasTree() {
      const currentDate = new Date();
      const currentYearDate = currentDate.getFullYear();
      const nextYearDate = currentYearDate + 1;
      const startChristmasDate = new Date(currentYearDate, 11, 14);
      const endChristmasDate = new Date(nextYearDate, 0, 14);

      return isWithinInterval(currentDate, { start: startChristmasDate, end: endChristmasDate });
    },
  },
};
</script>
